import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose, pure } from 'recompose';
import { layouts, pages } from './components';
import { routes } from './constants';

const Routes = () => (
  <Switch>
    <Route exact path={routes.home} component={layouts.Home} />
    <Route path={routes.adminPortal.root} component={layouts.AdminPortal} />
    <Route path={routes.root} component={layouts.App} />
    <Route component={pages.NotFound} />
  </Switch>
);

export default compose(
  withRouter,
  pure
)(Routes);



// WEBPACK FOOTER //
// ./src/routes.js